import { render, staticRenderFns } from "./dashboard_admin_sale.vue?vue&type=template&id=ef8cbc72&scoped=true"
import script from "./dashboard_admin_sale.vue?vue&type=script&lang=js"
export * from "./dashboard_admin_sale.vue?vue&type=script&lang=js"
import style0 from "./dashboard_admin_sale.vue?vue&type=style&index=0&id=ef8cbc72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8cbc72",
  null
  
)

export default component.exports